import { Component, OnDestroy, OnInit } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';
import { ConstantData } from 'src/app/services/constants';
import { DialogBoxService } from 'src/app/services/dialog-box.service';
import { WaitingScreenModel } from 'src/app/services/model';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-waiting-screen',
  templateUrl: './waiting-screen.component.html',
  styleUrls: ['./waiting-screen.component.scss']
})
export class WaitingScreenComponent implements OnInit, OnDestroy {

  options: AnimationOptions = {
    path: this.util.redirectionUrl + ConstantData.compassLoader,
  }
  selfieVerifyDialog: boolean = false;
  guardianFlowPopup:boolean = false;
  uploadSelfieStatus: any = {
    selfieUploading: true,
    waitingScreen: false,
    waitingScreen2: false,
  };

  timerCount: number = 20;
  homeRedirection:boolean = true;
  get isMoratorium():boolean{
    return (this.util.loanDetails.hasMoratorium || this.util.loanDetails.isCapacitaFlow) && !(!this.util.loanDetails.isStudentMainApplicant && !this.util.loanDetails.isSponser);
  }

  interval: any;

  constructor(private ds: DialogBoxService, private util: UtilService) { }

  ngOnInit(): void {
    this.ds.waitingDialogState.subscribe((res: WaitingScreenModel) => {
      this.selfieVerifyDialog = res.isShow;
      this.homeRedirection = res.isHome;
      if (res.isShow) {
        // this.timerCount -= 2;
      } else {
        this.timerCount = 20;
        clearInterval(this.interval);
        clearTimeout(this.interval);
      }
  //     if(this.util.loanDetails?.hasMoratorium) {
  //       console.log('waitingDialogState');
        
  //       setTimeout(() => {
  //         this.selfieVerifyDialog = false;
  //         this.guardianFlowPopup = true;
  //         setTimeout(() => {
  //           this.guardianFlowPopup = false;
  //           this.util.route('pan');
  //         }, 4000);
  //       }, 4000);
  
        
  // }else{
       this.initWaitingScreen(res);
  // }
    });
  }
  initWaitingScreen(data: WaitingScreenModel) {
    if (data.isShow) {
      switch (data.status) {
        case ConstantData.waitingScreenStatus.selfieUploading:
          if (this.interval) {
            clearInterval(this.interval);
          }

          this.interval = setInterval(() => {
            const loan = this.util.loanDetails;
           if(((this.isMoratorium) && this.util.getCurrentApplicant.mainApplicant &&  !this.util.getCurrentApplicant.selfiNotComplete)){
            this.ds.hidewaitingDialog(false);
            return;
           }

            if ( loan.loanApplicantDetails.every((app:any) => !app.selfiNotComplete)) {
              this.util.submitLoan();
              clearInterval(this.interval);
            }
          }, 2000)
          this.uploadSelfieStatus = { selfieUploading: true, };
          break;
        case ConstantData.waitingScreenStatus.waitingScreen:
          this.interval = setTimeout(()=>{
           this.initWaitingScreen({ status: ConstantData.waitingScreenStatus.waitingScreen2, isShow: true , isHome:true })
          }, this.timerCount * 1000);
          this.uploadSelfieStatus = { waitingScreen: true, };
          break;
        case ConstantData.waitingScreenStatus.waitingScreen2:
          this.interval = setInterval(() => {
            const sanl = this.util.getsanckbarStatus();
            if (sanl && !sanl?.isRepeat) {
              this.ds.hidewaitingDialog(false);
              setTimeout(() => {
                sanl.navigation();
              }, 500);
              
            }
          }, 2000);
          this.uploadSelfieStatus = { waitingScreen2: true, };
          break;
      }




    }
  }


  close(){
    this.ds.hidewaitingDialog(this.homeRedirection);
    if(this.homeRedirection)
    this.util.route('home');
  }
  ngOnDestroy(): void {
    clearInterval(this.interval);
  }



}
